import { useEffect } from "react";
import { motion } from "framer-motion";
import { Check, Mail } from "lucide-react";
import { LogoMark } from "@/components/site/Logo";
import { CONTACT_EMAIL } from "@/lib/content";

const ease = [0.16, 1, 0.3, 1];

export default function ThankYou() {
  useEffect(() => { document.title = "Thank you — Shaya Spiritual Practice"; }, []);
  return (
    <main data-testid="thank-you-page" className="min-h-screen bg-[#FBFBF8] grid place-items-center px-6 py-16 relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#E8D8C8]/60 blur-3xl" aria-hidden />
      <div className="relative max-w-xl text-center">
        <LogoMark className="w-12 h-12 mx-auto text-[#2D2A26]" />
        <motion.span initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.8, ease }}
          className="mx-auto mt-10 grid place-items-center w-14 h-14 rounded-full bg-[#EBF0EC] text-[#4F5F50]"><Check /></motion.span>
        <h1 data-testid="thank-you-title" className="mt-8 font-display font-light text-5xl sm:text-6xl text-[#2D2A26] leading-[1.05]">
          Thank you. <em className="text-[#A8613C]">Your booking is confirmed.</em>
        </h1>
        <p className="mt-6 text-base md:text-lg text-[#5E584F] leading-relaxed">
          A confirmation email is on its way to you. Diana will be in touch to confirm your reading time, or to let you know when your moon ritual is complete.
        </p>
        <p className="mt-8 font-display italic text-2xl text-[#2D2A26]">You are worthy. You are deserving. You are the gift.</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <a href="/" data-testid="thank-you-home-btn" className="btn-pill justify-center bg-[#2D2A26] text-[#FBFBF8] hover:bg-[#A8613C] px-7 py-4 text-sm">Return home</a>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="thank-you-email-btn" className="btn-pill justify-center border border-[#2D2A26]/30 text-[#2D2A26] hover:border-[#2D2A26] px-7 py-4 text-sm"><Mail size={16} /> Email Shaya</a>
        </div>
        <p className="mt-10 text-xs uppercase tracking-[0.25em] text-[#6E685F]">This practice honors the law of love</p>
      </div>
    </main>
  );
}
